import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { makeObservable } from 'mobx'
import i18n from 'i18next'
import Anchor from '../../UniformComponents/Anchor'

import './newHeader.scss'

const TRUNCATE_SHORT = 20
const TRUNCATE_LONG = 40
const pathsToTruncate = new Set(['productTitle', 'surveyTitle'])

@observer
class NewHeader extends Component {
    constructor(props) {
        super(props)
        makeObservable(this)
    }

    truncate = (str, length, name) => {
        if (!str) return ''
        if (pathsToTruncate.has(name) && str.length > length) return str.slice(0, length).concat('...')
        return str
    }

    renderBreadcrumb = () => {
        const { store } = this.props
        const breadcrumbsCopy = [...store.breadcrumps]
        const clientName = store.userData?.clientName || i18n.t('home')
        const isHome = breadcrumbsCopy.length < 1
        const isClientTruncated = clientName.length > (isHome ? TRUNCATE_LONG : TRUNCATE_SHORT)

        return !store.isLoginChoose && (
            <ul>
                <li>
                    <Anchor href="/" title={isClientTruncated ? clientName : null}>
                        {isHome
                            ? this.truncate(clientName, TRUNCATE_LONG)
                            : this.truncate(clientName, TRUNCATE_SHORT)}
                    </Anchor>
                </li>
                {breadcrumbsCopy.map((path, ind) => (
                    <>
                        <i className="fas fa-chevron-right" />
                        <li style={{ minWidth: !pathsToTruncate.has(path.name) ? 'auto' : '8px' }}>
                            <Anchor
                                href={path.url}
                                title={pathsToTruncate.has(path.name) && path.title
                                    && path.title.length > TRUNCATE_SHORT ? path.title : null}
                                cssClass={!pathsToTruncate.has(path.name) ? 'no-ellipsis' : ''}
                            >
                                {this.truncate(path.title, ind === breadcrumbsCopy.length -1 ? TRUNCATE_LONG : TRUNCATE_SHORT, path.name)}
                            </Anchor>
                        </li>
                    </>
                ))}
            </ul>
        )
    }

    render() {
        const { store } = this.props
        const removeLeftPad = store.loggedIn
            && store.tokenLoaded
            && store.isLoginChoose
        return (
            <div className={`header-wrapper ${removeLeftPad ? 'header-wrapper-left' : ''}`}>
                <div id="main-header">
                    <div id="breadcrumb">
                        {this.renderBreadcrumb()}
                    </div>
                    <div id="logo">
                        <a href="/">
                            <img src={`${process.env.CDN_URL}/images/logo_explori.png`} alt="Explori Logo" />
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewHeader
